import React from 'react';
import type { Platform } from './typings';

export const PlatformContext = React.createContext<Platform>('mobile');
